import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { SkeletonBlock } from "./SkeletonBlock.jsx";

export function AccountsRouteSkeleton() {
  const { c } = useThemeSlice();

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "14px 18px",
          borderBottom: `1px solid ${c.divider}`,
          flexShrink: 0,
        }}
      >
        <SkeletonBlock width="100%" height={36} style={{ maxWidth: 280 }} />
        <SkeletonBlock width={72} height={36} />
        <SkeletonBlock width={72} height={36} />
        <div style={{ marginLeft: "auto" }}>
          <SkeletonBlock width={120} height={36} />
        </div>
      </div>

      <div style={{ flex: 1, overflow: "hidden", padding: 18, background: c.bg }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, marginBottom: 18 }}>
          {[1, 2, 3].map((i) => (
            <SkeletonBlock key={i} height={72} radius={10} />
          ))}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <SkeletonBlock key={i} height={148} radius={12} />
          ))}
        </div>
      </div>
    </div>
  );
}
